<template>
  <div :class="schema?.cssClass" v-if="doneMounting">
    <FormEditor v-if="true" v-on:change="onUpdateForm" />

    <ComponentTree
      :key="schema?.lastUpdate || 1"
      :node="schema?.elements"
      :componentType="schema?.componentType"
      :nodeUUID="schema?.nodeUUID"
    />
  </div>
</template>

<script>
import api from "@/api/clientAPI.js";
import HTTPBase from "@/api/HTTPBase.js";
import FormEditor from "@/components/FormEditor.vue";
// import backButton from 'browser-back-button';
import ComponentMixin from "@/components/ComponentMixin.js";
// import testform from "@/components/001.tester.json"
// import testform from "@/components/methods.json"
import testform from "@/components/loader.json";

export default {
  name: "Formulario",
  components: {
    FormEditor,
  },
  mixins: [ComponentMixin],
  data() {
    return {
      doneMounting: false,
      api,
      schema: {
        elements: {},
        components: [],
      },
    };
  },
  created() {
    window.addEventListener("beforeunload", this.leaving);
  },
  methods: {
    async leaving() {
      if (window.api?.submitStats) {
        await window.api.submitStats({ leave: true });
      }
    },
    onUpdateForm(s) {
      window.creation_runs = window.creation_runs || 0
      window.creation_runs++

      this.schema = s || this.schema;

      api.setSchema(this.schema);
      api.setRootVueInstance(this);
      this.doneMounting = true;
      if (window.creation_runs == 1)
        api.eventPublish(api.events.EVENT_ON_CREATE);

    },
    async loadForm(paramID) {
      let form = await api.formFromDB(paramID);
      if (!form) {
        return null;
      }
      // form.json = JSON.parse(atob(form.json))
      this.onUpdateForm(form);
      /*
      setTimeout(() => {
        api.setCurrentPage(api.getCurrentPageIndex(), {});
      }, 500);
      */
      api.setConfiguration(form.configuracion);
      api.setObservability(form.observability);
      return form;
    },
  },
  async mounted() {
    document.addEventListener(
      "navigateToForm",
      async (e) => {
        let form = await this.loadForm(e.detail);
        if (!form) {
          console.log("Formulario no encontrado!" + e.detail);
          return;
        }
        window.document.title  = form.name
        this.onUpdateForm(form.json);
      },
      false
    );

    let paramID = api.getFormIDFromURL();
    window.console.log("paramID", paramID);

    HTTPBase.setAuth({
      username: "formclient",
      password: "formclient",
    });

    // this.onUpdateForm(testform)
    if (testform && window.neveExecute) this.onUpdateForm(testform);

    let form = await this.loadForm(paramID);
    if (form) {
      this.onUpdateForm(form.json);
      window.document.title  = form.name
    }
    else console.log("No se ha encontrado el formulario", paramID);
  },
};
</script>

<style>
</style>

